import { Button } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import * as XLSX from "xlsx"

function ExportToExcel({report,meters, parameters,filename}) {

  console.log(filename)
  

const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;
 
  const finalReport = []
  report?.filter(re => {
    const Date = re.date
    const data = {Date}
    meters?.forEach(meter => {
      if(re[meter]){
        data[meter] = re[meter]
      }
    })
    finalReport.push(data)
  })
  const exportTo = () => {
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.json_to_sheet(finalReport)

    XLSX.utils.book_append_sheet(wb, ws, `raw_data_report_${filename}`)
    XLSX.writeFile(wb, `raw_data_report_${filename}.xlsx`)
  }

  return (
    <div className={` ${isdarkMode ? 'exportbtn' : 'whitemode'}`}>
      <Button variant="contained" defaultColor='green' onClick={exportTo}>
        Export to Excel
      </Button>
    </div>
  );
}

export default ExportToExcel;